// Analytics tracking utility for React app
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const trackPageVisit = async (pageName) => {
    try {
        await fetch(`${API_BASE_URL}/api/track-page-visit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                page: pageName,
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent
            })
        });
        // console.log(`[ANALYTICS] Page visit tracked: ${pageName}`);
    } catch (error) {
        // console.error('[ANALYTICS] Page visit tracking error:', error);
    }
};

const trackFilterVisit = async () => {
    try {
        await fetch(`${API_BASE_URL}/api/track-filter-visit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent
            })
        });
        // console.log('[ANALYTICS] Filter visit tracked');
    } catch (error) {
        // console.error('[ANALYTICS] Filter visit tracking error:', error);
    }
};

export { trackPageVisit, trackFilterVisit };
